export default "__VITE_ASSET__BdMXR$0V__"